/* unplugin-vue-components disabled */import { render } from "./FeedingForm.vue?vue&type=template&id=2f583268&scoped=true&ts=true"
import script from "./FeedingForm.vue?vue&type=script&lang=ts"
export * from "./FeedingForm.vue?vue&type=script&lang=ts"

import "./FeedingForm.vue?vue&type=style&index=0&id=2f583268&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f583268"]])

export default __exports__